angular.module('ihestiaRestServicesBase')

/**
 * klauzule produktowe
 */
  .service('apkRestSvc', ['IHestiaRestServiceAbstractDef', function(IHestiaRestServiceAbstractDef) {

    /**
     * Główny konstruktor
     */
    var ApkRestSvc = function() {
      IHestiaRestServiceAbstractDef.apply(this, arguments);
      var self = this;
      this.resource = 'apk';
      this.businessArea = 'apk';
      this.port = '8201';
      this.path = 'RestApplications';

      /**
       * pobranie klauzul produktowych dla wniosku
       *
       * @param {String} id
       * @param {String} appMode
       * @param {String} offerId
       * @param {Object} data
       * @param {function} callback
       * @returns {*}
       */
      this.getApk = function(id, callback, errorCallback, httpParams) {
        if(typeof httpParams === 'undefined' || httpParams === null)
        {
          httpParams = {};
        }

        httpParams.allowedStatuses = [403, 404, 409, 500, 503];
        return self.get(id, null, null, callback, errorCallback, httpParams);
      };

    };
    
    return new ApkRestSvc();
  }]);